class KlarnaPaymentService {
    /*@ngInject*/
    constructor($log, $rootScope, $http, $compile, $timeout, CommonService) {
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.$http = $http;
        this.$compile = $compile;
        this.$timeout = $timeout;
        this.CommonService = CommonService;
    }

    initWidget(klarnaPaymentClientToken) {
        if (klarnaPaymentClientToken !== null) {
            Klarna.Payments.init({
                client_token: klarnaPaymentClientToken
            });
        }
    }

    loadWidget() {
        Klarna.Payments.load({
            container: '#klarna-payments-container',
            payment_method_category: 'klarna'
        }, function (res) {
        });
    }

    authorize(callback, form, redirectUrl) {
        Klarna.Payments.authorize({}, {},
            function (res) {
                callback(res, form, redirectUrl);
            });
    }
}

export default KlarnaPaymentService;
